module.exports = __webpack_public_path__ + "img/p1.6d86179f.png";